package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.domain.repository.KeycloakRepository
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.HttpMethod
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonArray

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import com.clany.backoffice.di.AppScope

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class KeycloakRepositoryImpl(
    private val networkClient: NetworkClient
) : KeycloakRepository {

    override suspend fun updateUser(request: UpdateUserRequest): Result<Unit> {
        return try {
            val url = "${KeycloakConfig.AUTH_URL}/admin/realms/${KeycloakConfig.REALM}/users/${request.id}"
            
            // Map UpdateUserRequest to Keycloak UserRepresentation JSON structure
            // We use generic JsonObject to avoid creating a dedicated data class for Keycloak UserRepresentation in client
            val keycloakBody = buildJsonObject {
                put("firstName", request.firstName)
                put("lastName", request.lastName)
                // Add other standard fields if needed (email, etc. if in request)
                
                // Custom Attributes
                put("attributes", buildJsonObject {
                    putJsonArray("locale") { add(JsonPrimitive(request.locale)) }
                    putJsonArray("type") { add(JsonPrimitive(request.type.name)) }
                    if (request.linkedMemberId != null) {
                        putJsonArray("linkedMemberId") { add(JsonPrimitive(request.linkedMemberId)) }
                    }
                    if (request.pictureUrl != null) {
                        putJsonArray("pictureUrl") { add(JsonPrimitive(request.pictureUrl)) }
                    }
                    putJsonArray("shouldUpdateTyc") { add(JsonPrimitive(request.shouldUpdateTyc.toString())) }
                })
            }

            return networkClient.request<Unit>(url, HttpMethod.Put, keycloakBody) {
                contentType(ContentType.Application.Json)
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
